// @flow
import React, { Component } from 'react';
import {
  SignupStatDiv,
  SignupStatImg,
  SignupStatH4,
  SignupStatValueH2
} from './SignupsStyles';

type Props = {
  image: string,
  label: string,
  value: number,
  color: string
};

export default class SignupStat extends Component<Props> {
  render() {
    return (
      <SignupStatDiv>
        <SignupStatImg src={this.props.image} />
        <SignupStatH4>{this.props.label}</SignupStatH4>
        <SignupStatValueH2 color={this.props.color}>
          {this.props.value}
        </SignupStatValueH2>
      </SignupStatDiv>
    );
  }
}
